/*
 * ck-whatsapp-region.js — region-aware WhatsApp lines.
 *
 * The store sells to two markets (SG · +65 / MY · +60). Every "message us on
 * WhatsApp" action must point at the workshop of the market the customer is in.
 * The active region is decided server-side (body[data-region], from the same
 * localization country that drives the SG/MY toggle) and exposed as window.CK_WA
 * (defined in layout/theme.liquid — the single source of truth for both numbers).
 *
 * This script rewrites every wa.me link on the page — and the visible number
 * shown inside those links — to the active region's number. It also watches for
 * links added later (the estimator / claims / airline flows build their hrefs in
 * JS) so those get corrected too. On the SG region every swap is a no-op, so this
 * only ever changes anything when the customer has toggled to Malaysia.
 */
(function () {
  var W = window.CK_WA;
  if (!W || !W.numbers) return;

  var SG = W.numbers.sg;
  var MY = W.numbers.my;
  var TARGET = W.number;              // active region's digits
  var DISP = W.display;               // active region's shown number
  var SG_DISP = W.displays.sg;
  var MY_DISP = W.displays.my;

  // Nothing to do on the Singapore region — SG is the default everywhere.
  var ACTIVE_ONLY = (TARGET !== SG);

  function swapHref(href) {
    if (!href || href.indexOf('wa.me/') === -1) return href;
    return href.split('wa.me/' + SG).join('wa.me/' + TARGET)
               .split('wa.me/' + MY).join('wa.me/' + TARGET);
  }

  function swapText(node) {
    // Replace the visible SG/MY number with the active display, in text nodes only,
    // so button labels like "WhatsApp +65 9100 2680" follow the region.
    if (!ACTIVE_ONLY) return;
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    var t;
    while ((t = walker.nextNode())) {
      var v = t.nodeValue;
      if (v.indexOf(SG_DISP) !== -1) t.nodeValue = v.split(SG_DISP).join(DISP);
      else if (MY_DISP && v.indexOf(MY_DISP) !== -1) t.nodeValue = v.split(MY_DISP).join(DISP);
    }
  }

  function fixAnchor(a) {
    // Per-branch WhatsApp links are locked to their workshop's own country — leave them.
    if (a.hasAttribute('data-ck-wa-lock')) return;
    var href = a.getAttribute('href');
    if (!href || href.indexOf('wa.me/') === -1) return;
    var next = swapHref(href);
    if (next !== href) a.setAttribute('href', next);
    swapText(a);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('a[href*="wa.me/"]');
    for (var i = 0; i < links.length; i++) fixAnchor(links[i]);
  }

  function run() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Links built after load (estimator / claims / airline results) — keep them correct.
  if (ACTIVE_ONLY && 'MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.target && m.target.tagName === 'A') {
          fixAnchor(m.target);
        }
        if (m.addedNodes) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'A') fixAnchor(n);
            if (n.querySelectorAll) scan(n);
          }
        }
      }
    });
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }
})();
